export default __webpack_public_path__ + "static/media/price-list.3454179c.svg";